
import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { useSelector } from "react-redux"
import {MdKeyboardArrowRight} from "react-icons/md"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { getLocationSearchResult, getSearchResultBoundaries, setSearchText } from "../../../features/boundaries/boundariesSlice"

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    /* background-color: ${({theme}) => theme.mainBgColor}; */
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        padding-right: 30px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        border-bottom-left-radius: ${({isActive}) => isActive && 0};
        border-bottom-right-radius: ${({isActive}) => isActive && 0};
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
        color: ${({showErrors}) => showErrors && "var(--color-red)"};

    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
        color: ${({showErrors}) => showErrors && "var(--color-red)"};
    }

    .arr-icon{
        position: absolute;
        right: 5px;
        top: 8px;
        transform: ${({isActive}) => isActive ? "rotate(90deg)": "rotate(0)"};
        font-size: 1.6rem;
        color: ${({ theme }) => theme.mainTextColor};
        transition: .3s;
    }

    .options{
        position: absolute;
        top: 40px;
        background-color: ${({theme}) => theme.mainBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 100%;
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        max-height: 300px;
        overflow: auto;

        .option{
            width: 100%;
            padding: 9px 20px;
            cursor: pointer;
            font-size: 12px;
            font-weight: var(--font-weight-md);
            color: ${({ theme }) => theme.mainTextColor};
            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }

        
        /* &::-webkit-scrollbar {
            width: 8px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({theme})=> theme.secondaryTextColor};
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        } */
    }

`

const InputPlacesForBoundaries = ({ name, inputWidth}) => {
    
    const dispatch = useDispatch()

    const {searchText, isLoadingGetLocationSearchResult, locationSearchResultList} = useSelector(state => state.boundaries)
    const [typingTimeout, setTypingTimeout] = useState(null);

    const {activeSelect} = useSelector(state => state.layout)

    const handleChange = (e) => {
        dispatch(setSearchText(e.target.value))
    
        // Eğer daha önce bir timeout ayarlanmışsa iptal et
        if (typingTimeout) {
          clearTimeout(typingTimeout);
        }
    
        // Yeni bir timeout ayarla
        const timeout = setTimeout(() => {
            if(e.target.value.length > 2){
                dispatch(getLocationSearchResult(e.target.value))
            }
        }, 1000); // 2 saniye (2000 ms)
    
        setTypingTimeout(timeout);
    };

    const handleOptionClick = async (optionItem) => {

        dispatch(getSearchResultBoundaries({
            regionId: optionItem.regionId,
            cityId: optionItem.cityId,
            townId: optionItem.townId,
            type: (optionItem.regionId && optionItem.cityId && optionItem.townId) ? "town" : (optionItem.regionId && optionItem.cityId) ?"city" : "region",
            quarterId: null,
        }))
        
        // dispatch(setSearchText([optionItem?.townName, optionItem?.cityName, optionItem?.regionName].filter(Boolean).join(', ')))
        dispatch(setSearchText(""))
        dispatch(handleActiveSelect(null))

    }



  return (
    <Container value={searchText} radius={"5px"} isActive={activeSelect === name} inputWidth={inputWidth} onClick={(e) => e.stopPropagation()}>
        
        <input
            type="text"
            id={"text"}
            onChange={handleChange}
            value={searchText}
            name={name}
            placeholder="İl, İlçe Ara"
            onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))}
            autoComplete="off"/>
        <MdKeyboardArrowRight className="arr-icon"/>
            {
                activeSelect === name &&
                <div className="options">
                    {
                        locationSearchResultList.map((item) => (
                        <div className="option" onClick={() => handleOptionClick(item)}>{item?.townName && `${item.townName}, `}{item?.cityName && `${item.cityName}, `}{item?.regionName}</div>
                        ))
                    }
                </div>
            }
    </Container>
  )
}

export default InputPlacesForBoundaries